<div class="padding-responsive flex items-center justify-between w-full custom-header--height"
    [class.header-fixed-bar]="!hideSubmenu()" [class.header-static-bar]="hideSubmenu()" style="background-color: #0B7749;">
    <div class="flex items-center gap-3">
        <div class="relative inline-block text-left">
            <ek-button *ngIf="hasSelectedTeaching$ | async" [icon]="'menu'" [styleClass]="'bg-blue-600 hover:bg-blue-700 text-white'" [ekStyle]="'text'"
                (click)="toggleMenu($event)"></ek-button>
        </div>
        <app-logo />
        <h3 class="text-white text-4xl">{{ 'LUMIA_TITLE' | translate }}</h3>
    </div>
    <app-navbar [showFeedbackButton]="showFeedbackButton()" (feedbackClick)="feedbackClick.emit()"></app-navbar>
</div>

<div class="padding-responsive custom-header--submenu" [style]="'background-color: #DAEBE4;'" *ngIf="showSubmenu && !hideSubmenu()">
    <div class="flex justify-between items-start mb-4">
        <div class="mb-16">
            <ek-breadcrumb [model]="items" [home]="home" />
        </div>
        
    
        <div class="p-toolbar-group-end flex gap-4">
            <span *ngIf="showExamStatus && examStatus" 
                  class="status-chip"
                  [ngClass]="{
                    'status-unsaved': examStatus === 'UNSAVED',
                    'status-bozza': examStatus === 'BOZZA',
                    'status-completato': examStatus === 'COMPLETATO'
                  }">
                <span class="material-icons status-icon">
                    {{ examStatus === 'UNSAVED' ? '' : examStatus === 'BOZZA' ? 'pause_circle_outline' : 'cloud_done' }}
                </span>
                <span class="status-text">{{ examStatus === 'UNSAVED' ? ('CUSTOM_HEADER.STATUS_UNSAVED' | translate) : examStatus === 'BOZZA' ? ('CUSTOM_HEADER.STATUS_DRAFT' | translate) : ('CUSTOM_HEADER.STATUS_COMPLETED' | translate) }}</span>
            </span>
            <ek-button (click)="openChangeModal()" [ekStyle]="'text'" [icon]="'topic'" *ngIf="(canOpenChangeModal$ | async) && !(isExamEditOrCreateMode$ | async)"></ek-button>
            <ek-button (click)="openLegendModal()" [ekStyle]="'text'" [icon]="'info'"></ek-button>
        </div>
    </div>
    <h2 class="text-5xl">{{ pageTitle }}</h2>

    <div class="submenu-section">
        <div *ngIf="pageSubtitle" class="nav-submenu">
            <div class="dropdown-header" style="color: #0B7749; font-size: 1.5rem; padding-top: 0.75rem;">
                {{ pageSubtitle }}
            </div>
        </div>
        <nav-submenu *ngIf="!pageSubtitle"></nav-submenu>
    </div>
</div>

<div class="layout-sidebar layout-sidebar-left" [class.active]="isMenuOpen" *ngIf="hasSelectedTeaching$ | async">
    <app-menu [isOpen]="isMenuOpen" [headerTitle]="headerTitle"
        (closeMenuRequest)="handleMenuCloseRequest()"></app-menu>
</div>

<div class="menu-overlay" *ngIf="isMenuOpen" (click)="handleMenuCloseRequest()"></div>